import { ColorOak, LegsColorSteel, TopColorCeramic, TopColorFenix, TopFinish, TopMaterial } from '../__generated/model/index.js';
export const Textures = {
    TOP_CERAMIC_ROUGHNESS_URL: '/textures/ceramics_Roughness.webp',
    TOP_LIVED_OAK_BASE_COLOR_URL: '/textures/wood_lived_baseColor.webp',
    TOP_LIVED_OAK_NORMAL_URL: '/textures/wood_lived_normal.webp',
    TOP_LIVED_OAK_ROUGHNESS_URL: '/textures/wood_lived_roughness.webp',
    TOP_REFINED_OAK_BASE_COLOR_URL: '/textures/wood_refined_baseColor.webp',
    TOP_REFINED_OAK_NORMAL_URL: '/textures/wood_refined_normal.webp',
    TOP_REFINED_OAK_ROUGHNESS_URL: '/textures/wood_refined_roughness.webp',
    TOP_OAK_BASE_COLOR_URL: '/textures/wood_new_baseColor.webp',
    TOP_OAK_NORMAL_URL: '/textures/wood_new_normal.webp',
    TOP_OAK_ROUGHNESS_URL: '/textures/wood_new_roughness.webp',
    STEEL_NORMAL_URL: '/textures/steel_Normal.webp',
    STEEL_ROUGHNESS_URL: '/textures/steel_Roughness.webp',
    BasicNieve: '/textures/basic_nieve.webp',
    BiancoSupreme: '/textures/bianco_supreme.webp',
    BlueStoneNegro: '/textures/blue_stone_negro.webp',
    CalacataGold: '/textures/calacata_gold.webp',
    CalacataNaturel: '/textures/calacata_naturel.webp',
    CalacataVaglie: '/textures/calacata_vaglie.webp',
    CalceGrigio: '/textures/calce_grigio.webp',
    CeppoDeGre: '/textures/ceppo_de_gre.webp',
    ClassicCarrara: '/textures/classic_carrara.webp',
    CuarzoReno: '/textures/cuarzo_reno.webp',
    DarkBlack: '/textures/dark_black.webp',
    HyperWhite: '/textures/hyper_white.webp',
    LavaCorten: '/textures/lava_corten.webp',
    MacchiaVecchia: '/textures/macchia_vecchia.webp',
    NeroArdi: '/textures/nero_ardi.webp',
    NeroZimbabwe: '/textures/nero_zimbabwe.webp',
    NoirDesir: '/textures/noir_desir.webp',
    PaladioNaturel: '/textures/paladio_naturel.webp',
    SurfaceCoolGrey: '/textures/surface_cool_grey.webp',
    SurfaceOffWhite: '/textures/surface_off_white.webp',
    SurfaceSand: '/textures/surface_sand.webp',
    TajMahal: '/textures/taj_mahal.webp',
    TitanCemento: '/textures/titan_cemento.webp',
    Travertin: '/textures/travertin.webp'
};
// Note that these are for use in materials only, some of the swatch colors are different
const ColorOakColors = {
    [ColorOak.UltraMatteLak]: '#DCB083',
    [ColorOak.Oyster]: '#A47652',
    [ColorOak.DarkOak]: '#845737',
    [ColorOak.Charcoal]: '#553E2E',
    [ColorOak.SlateGrey]: '#675144',
    [ColorOak.CottonWhite]: '#C4A68E',
    [ColorOak.Black]: '#2B2B2B'
};
export const SteelLegProperties = {
    [LegsColorSteel.RAL9005]: {
        color: '#1A1A1A'
    },
    [LegsColorSteel.RAL9016]: {
        color: '#DDDDDD'
    },
    [LegsColorSteel.AnodicGold]: {
        color: '#8F6941'
    },
    [LegsColorSteel.AnodicBronze]: {
        color: '#8C7853'
    },
    [LegsColorSteel.AnodicBrown]: {
        color: '#563435'
    }
};
export const OakLegProperties = {
    [TopColorCeramic.CuarzoReno]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.NeroZimbabwe]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.BiancoSupreme]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.CalacataVaglie]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.TajMahal]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.MacchiaVecchia]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.CalacataNaturel]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.BlueStoneNegro]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.CeppoDeGre]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.NeroArdi]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.PaladioNaturel]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.CalceGrigio]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.TitanCemento]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.LavaCorten]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.BasicNieve]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.Travertin]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.CalacataGold]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.SurfaceSand]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.SurfaceOffWhite]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.NoirDesir]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.SurfaceCoolGrey]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.HyperWhite]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.DarkBlack]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorCeramic.ClassicCarrara]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorFenix.BiancoKos0032]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorFenix.BeigeLuxor0719]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorFenix.NeroIngo0720]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorFenix.VerdeComodoro0750]: {
        color: ColorOakColors.UltraMatteLak
    },
    [TopColorFenix.VerdeBrac0773]: {
        color: ColorOakColors.UltraMatteLak
    },
    [ColorOak.UltraMatteLak]: {
        color: ColorOakColors.UltraMatteLak
    },
    [ColorOak.Oyster]: {
        color: ColorOakColors.Oyster
    },
    [ColorOak.DarkOak]: {
        color: ColorOakColors.DarkOak
    },
    [ColorOak.Charcoal]: {
        color: ColorOakColors.Charcoal
    },
    [ColorOak.SlateGrey]: {
        color: ColorOakColors.SlateGrey
    },
    [ColorOak.CottonWhite]: {
        color: ColorOakColors.CottonWhite
    },
    [ColorOak.Black]: {
        color: ColorOakColors.Black
    }
};
export const TopProperties = {
    [`${TopMaterial.SolidOak}_${TopFinish.LivedOak}_${ColorOak.UltraMatteLak}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.UltraMatteLak,
        textureUrl: Textures.TOP_LIVED_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_LIVED_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_LIVED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.LivedOak}_${ColorOak.Oyster}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.Oyster,
        textureUrl: Textures.TOP_LIVED_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_LIVED_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_LIVED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.LivedOak}_${ColorOak.DarkOak}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.DarkOak,
        textureUrl: Textures.TOP_LIVED_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_LIVED_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_LIVED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.LivedOak}_${ColorOak.Charcoal}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.Charcoal,
        textureUrl: Textures.TOP_LIVED_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_LIVED_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_LIVED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.LivedOak}_${ColorOak.SlateGrey}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.SlateGrey,
        textureUrl: Textures.TOP_LIVED_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_LIVED_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_LIVED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.LivedOak}_${ColorOak.CottonWhite}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.CottonWhite,
        textureUrl: Textures.TOP_LIVED_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_LIVED_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_LIVED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.LivedOak}_${ColorOak.Black}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.Black,
        textureUrl: Textures.TOP_LIVED_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_LIVED_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_LIVED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.RefinedOak}_${ColorOak.UltraMatteLak}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.UltraMatteLak,
        textureUrl: Textures.TOP_REFINED_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_REFINED_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.RefinedOak}_${ColorOak.Oyster}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.Oyster,
        textureUrl: Textures.TOP_REFINED_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_REFINED_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.RefinedOak}_${ColorOak.DarkOak}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.DarkOak,
        textureUrl: Textures.TOP_REFINED_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_REFINED_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.RefinedOak}_${ColorOak.Charcoal}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.Charcoal,
        textureUrl: Textures.TOP_REFINED_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_REFINED_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.RefinedOak}_${ColorOak.SlateGrey}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.SlateGrey,
        textureUrl: Textures.TOP_REFINED_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_REFINED_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.RefinedOak}_${ColorOak.CottonWhite}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.CottonWhite,
        textureUrl: Textures.TOP_REFINED_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_REFINED_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.RefinedOak}_${ColorOak.Black}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.Black,
        textureUrl: Textures.TOP_REFINED_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_REFINED_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.NewOak}_${ColorOak.UltraMatteLak}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.UltraMatteLak,
        textureUrl: Textures.TOP_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.NewOak}_${ColorOak.Oyster}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.Oyster,
        textureUrl: Textures.TOP_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.NewOak}_${ColorOak.DarkOak}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.DarkOak,
        textureUrl: Textures.TOP_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.NewOak}_${ColorOak.Charcoal}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.Charcoal,
        textureUrl: Textures.TOP_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.NewOak}_${ColorOak.SlateGrey}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.SlateGrey,
        textureUrl: Textures.TOP_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.NewOak}_${ColorOak.CottonWhite}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.CottonWhite,
        textureUrl: Textures.TOP_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.NewOak}_${ColorOak.Black}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.Black,
        textureUrl: Textures.TOP_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.None}_${ColorOak.UltraMatteLak}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.UltraMatteLak,
        textureUrl: Textures.TOP_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.None}_${ColorOak.Oyster}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.Oyster,
        textureUrl: Textures.TOP_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.None}_${ColorOak.DarkOak}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.DarkOak,
        textureUrl: Textures.TOP_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.None}_${ColorOak.Charcoal}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.Charcoal,
        textureUrl: Textures.TOP_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.None}_${ColorOak.SlateGrey}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.SlateGrey,
        textureUrl: Textures.TOP_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.None}_${ColorOak.CottonWhite}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.CottonWhite,
        textureUrl: Textures.TOP_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    [`${TopMaterial.SolidOak}_${TopFinish.None}_${ColorOak.Black}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        fileUrl: '/models/algu3d.glb',
        materialName: 'TableTopMaterial',
        color: ColorOakColors.Black,
        textureUrl: Textures.TOP_OAK_BASE_COLOR_URL,
        normalMapUrl: Textures.TOP_OAK_NORMAL_URL,
        roughnessMapUrl: Textures.TOP_REFINED_OAK_ROUGHNESS_URL,
        roughness: 1,
        normalScale: 0.8,
        envMapIntensity: 2
    },
    // Ceramics
    [`${TopMaterial.Ceramic}_${TopColorCeramic.BasicNieve}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.BasicNieve,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.BiancoSupreme}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.BiancoSupreme,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.BlueStoneNegro}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.BlueStoneNegro,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.CalacataGold}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.CalacataGold,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.CalacataNaturel}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.CalacataNaturel,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.CalacataVaglie}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.CalacataVaglie,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.CalceGrigio}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.CalceGrigio,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.CeppoDeGre}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.CeppoDeGre,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.ClassicCarrara}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.ClassicCarrara,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.CuarzoReno}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.CuarzoReno,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.DarkBlack}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.DarkBlack,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.HyperWhite}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.HyperWhite,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.LavaCorten}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.LavaCorten,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.MacchiaVecchia}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.MacchiaVecchia,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.NeroArdi}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.NeroArdi,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.NeroZimbabwe}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.NeroZimbabwe,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.NoirDesir}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.NoirDesir,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.PaladioNaturel}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.PaladioNaturel,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.SurfaceCoolGrey}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.SurfaceCoolGrey,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.SurfaceOffWhite}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.SurfaceOffWhite,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.SurfaceSand}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.SurfaceSand,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.TajMahal}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.TajMahal,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.TitanCemento}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.TitanCemento,
        roughness: 0.9
    },
    [`${TopMaterial.Ceramic}_${TopColorCeramic.Travertin}`]: {
        materialsToOverride: [
            'TableTopMaterial'
        ],
        color: '#FFFFFF',
        textureUrl: Textures.Travertin,
        roughness: 0.9
    },
    // Fenix
    [`${TopMaterial.Fenix}_${TopColorFenix.BiancoKos0032}`]: {
        materialsToOverride: [
            'TableTopMaterial',
            'FenixTopLayerMaterial'
        ],
        color: '#FCFCFC',
        roughness: 0.5
    },
    [`${TopMaterial.Fenix}_${TopColorFenix.BeigeLuxor0719}`]: {
        materialsToOverride: [
            'TableTopMaterial',
            'FenixTopLayerMaterial'
        ],
        color: '#B6A58B',
        roughness: 0.5
    },
    [`${TopMaterial.Fenix}_${TopColorFenix.NeroIngo0720}`]: {
        materialsToOverride: [
            'TableTopMaterial',
            'FenixTopLayerMaterial'
        ],
        color: '#141414',
        roughness: 0.5
    },
    [`${TopMaterial.Fenix}_${TopColorFenix.VerdeComodoro0750}`]: {
        materialsToOverride: [
            'TableTopMaterial',
            'FenixTopLayerMaterial'
        ],
        color: '#6D7675',
        roughness: 0.5
    },
    [`${TopMaterial.Fenix}_${TopColorFenix.VerdeBrac0773}`]: {
        materialsToOverride: [
            'TableTopMaterial',
            'FenixTopLayerMaterial'
        ],
        color: '#63796B',
        roughness: 0.5
    }
};

//# sourceMappingURL=materials.js.map